import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function CircleNotificationsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"circle_notifications"}/>
}
